import React from 'react';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import type { CustodyCase } from '../../types/case';
import { useStore } from '../../contexts/StoreContext';
import { categoryLabel, stageInfo } from '../../utils/caseStatus';
import { fmtDateTime } from '../../utils/bn';
import { StatusBadge } from '../shared/StatusBadge';
export function CaseMiniCard({
  c,
  onClick,
  extra
}: {
  c: CustodyCase;
  onClick?: () => void;
  extra?: React.ReactNode;
}) {
  const {
    config
  } = useStore();
  const s = stageInfo(c);
  return <button onClick={onClick} className="card flex w-full gap-3 p-3 text-left transition-shadow duration-150 hover:shadow-pop" data-id="element-110" data-mp="2c8f4xpt38s9q">
      <img src={c.photo} alt="" className="h-16 w-16 shrink-0 rounded-lg object-cover" data-id="element-111" data-mp="2q6vgpv5t58yq" />
      <div className="min-w-0 flex-1" data-id="element-112" data-mp="2laoeodgj8hm2">
        <div className="flex items-center justify-between gap-2" data-id="element-113" data-mp="vuf50eu8t2mh">
          <span className="font-mono text-xs font-bold text-navy" data-id="element-114" data-mp="vx1ewl4lvu7v">{c.pcr}</span>
          <ChevronRightIcon className="h-4 w-4 text-ink-soft" data-id="element-115" data-mp="qxf22csowfzl" />
        </div>
        <p className="truncate text-sm font-semibold text-ink" data-id="element-116" data-mp="3iwfvf6zr2cxl">{c.regNo}</p>
        <p className="truncate text-xs text-ink-muted" data-id="element-117" data-mp="3nty91aoppgbx">{categoryLabel(c.category, config)} · {c.reason}</p>
        <div className="mt-1.5 flex flex-wrap items-center gap-2" data-id="element-118" data-mp="3stasdlgdk59r">
          <StatusBadge label={s.label} tone={s.tone} size="sm" data-id="element-119" data-mp="1ewnvnfg84ja" />
          {extra ?? <span className="flex items-center gap-0.5 text-[11px] text-ink-soft" data-id="element-120" data-mp="1gpx9ahg52uz"><MapPinIcon className="h-3 w-3" data-id="element-121" data-mp="5fyq8d4nwwph" />{c.location.label} · {fmtDateTime(c.createdAt)}</span>}
        </div>
      </div>
    </button>;
}